import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      props: true
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/copyright',
      name: 'copyright',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Copyright.vue')
    },
    {
      path: '/school/:province/:level/:id',
      name: 'schoolpage',
      component: () => import('./views/SchoolPage.vue'),
      props: true
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import('./views/Faq.vue')
    },
    {
      path: '/about-rankings',
      name: 'about rankings',
      component: () => import('./views/AboutRankings.vue')
    },
    {
      path: '/pdfs',
      name: 'report card pdfs',
      component: () => import('./views/Pdfs.vue'),
    }
  ]
})
